<template>
  <div v-if="isObject(infogeneral) && !isEmptyObject(infogeneral)">
    <b-card
      :key="infogeneral.avatar"
    >
      <div
        class="d-flex justify-content-start align-items-center m-2"
      >
        <div class="profile-user-info">
          <h2 class="mb-0">
            {{ infogeneral.title }}
          </h2>
        </div>
      </div>

      <b-card-text class="m-2">
        <div v-html="infogeneral.descripcion"></div>
      </b-card-text>

      <div class="d-flex justify-content-end">
        <feather-icon
          icon="BookOpenIcon"
          class="mr-50 text-muted"
          size="18"
        />
        <span class="text-muted mr-1">{{ totalEdiciones }} Publicaciones </span>
      </div>

    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardText
} from 'bootstrap-vue'
import store from '@/store'
import { computed } from '@vue/composition-api'
import { isObject, isEmptyObject } from '@core/utils/utils'

export default {
  components: {
    BCard,
    BCardText,
  },
  props: {
    infogeneral: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    const totalEdiciones = computed(() => store.state.ediciones.fullItems.length)
    return {
      totalEdiciones,
      isObject,
      isEmptyObject,
    }
  },
}
</script>
